/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useRef } from 'react'
import CurrentUserContext from "../../Contexts/userContexts";
import "./DisplayInformation.css";
import { HiOutlineEmojiHappy } from "react-icons/hi";

const DisplayInformation = () => {
  const { playerSelectState, displaymessage, setDisplaymessage } = useContext(CurrentUserContext)

  useEffect(() => {
    const timer = setTimeout(() => {
      setDisplaymessage(false);
    }, 2500);
    return () => clearTimeout(timer);
  }, [playerSelectState]);


  let messageRef = useRef()
  useEffect(() => {
    const maybeHandler = (event) => {
      if (messageRef.current !== null && messageRef.current !== undefined && Object.keys(messageRef.current).length !== 0) {
        if (!messageRef.current.contains(event.target)) {
          setDisplaymessage(false);
        }
      }
    }


    document.addEventListener("mousedown", maybeHandler);

    return () => {
      document.removeEventListener("mousedown", maybeHandler);
    };
  });

  return (
    <div className="displayContainer" style={{ display: (displaymessage ? "flex" : "none") }} ref={messageRef}>
      <div className='displaymessage' >
        <div><HiOutlineEmojiHappy style={{ transform: 'scale(2)' }} /></div>
        <div>{`${playerSelectState} is part of your team`}</div>
      </div>
    </div>
  )
}

export default DisplayInformation;